import { styled, Tooltip, TooltipProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const PaperTooltip = styled(
  ({
    className,
    children,
    slotProps,
    ...props
  }: PropsWithChildren<TooltipProps>) => (
    <Tooltip
      {...props}
      slotProps={{
        ...slotProps,
        tooltip: { className },
      }}
    >
      {children}
    </Tooltip>
  ),
)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  boxShadow: theme.shadows[4],
  padding: theme.spacing(2),
  color: theme.palette.secondary.contrastText,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
  },
}));
